/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespTradeOnApprovalCoachmarkLoader_item$ref = any;
type SharedContactDealerWrapper_item$ref = any;
type TradeOnboardingCoachmarkConditionalLoader_item$ref = any;
export type PdpSharedContactDealerButton_item$ref = any;
export type PdpSharedContactDealerButton_item = {
    readonly " $fragmentRefs": SharedContactDealerWrapper_item$ref & TradeOnboardingCoachmarkConditionalLoader_item$ref & PdpRespTradeOnApprovalCoachmarkLoader_item$ref;
    readonly " $refType": PdpSharedContactDealerButton_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedContactDealerButton_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespTradeOnApprovalCoachmarkLoader_item",
      "args": null
    }
  ]
};
(node as any).hash = 'b6d88fb697028e1a787220019b7f1e0e';
export default node;
